export const materialOrderItems = [
  {
    id: "abaca-pulp",
    category: "Pulp & fiber",
    status: "Buy now",
    name: "Abaca Sheet Pulp",
    supplier: "Arnold Grummer",
    package: "5 lb or 1 lb",
    estimatedPrice: 69.09,
    url: "https://arnoldgrummer.com/products/pulps/abaca-sheet-pulp.html",
    note: "Primary wet-strength and wicking fiber.",
    defaultSelected: true,
  },
  {
    id: "seed-paper-pulp",
    category: "Pulp & fiber",
    status: "Buy now",
    name: "Seed Paper Pulp",
    supplier: "Arnold Grummer",
    package: "8 oz",
    estimatedPrice: 19.79,
    url: "https://arnoldgrummer.com/seed-paper-pulp-8oz.html",
    note: "Use at 2% of dry paper mass.",
    defaultSelected: true,
  },
  {
    id: "cotton-linter",
    category: "Pulp & fiber",
    status: "Buy now",
    name: "Cotton Linter Sheet Pulp",
    supplier: "Arnold Grummer",
    package: "1 lb",
    estimatedPrice: 8.79,
    url: "https://arnoldgrummer.com/cotton-linter-by-the-pound.html",
    note: "Soft cellulose backup and formation trial fiber.",
    defaultSelected: true,
  },
  {
    id: "hemp-mats",
    category: "Pulp & fiber",
    status: "Buy now",
    name: "TerraFibre Hemp Grow Mats",
    supplier: "Johnny's Selected Seeds",
    package: "10 x 20 in, 140 count",
    estimatedPrice: 25.95,
    url: "https://www.johnnyseeds.com/tools-supplies/microgreens-supplies/terrafibre-hemp-grow-mats-10%22-x-20%22-140-count-microgreens-accessory-7549.html",
    note: "Capillarity trial and loose-seed control substrate.",
    defaultSelected: true,
  },
  {
    id: "coco-mats",
    category: "Pulp & fiber",
    status: "Optional",
    name: "Hydro-Crunch Coco Coir Mats",
    supplier: "Home Depot",
    package: "10 pack",
    estimatedPrice: null,
    url: "https://www.homedepot.com/p/Hydro-Crunch-Coco-Coir-Fiber-Hydroponic-Microgreen-Grow-Mat-Seed-Starter-for-10-in-x-20-in-Trays-10-Pack-CM801/317009794",
    note: "Backup fiber trial; rinse and test pH/EC before use.",
    defaultSelected: false,
  },
  {
    id: "kelp",
    category: "Paper additives",
    status: "Future/test",
    name: "Kelp It Real Soluble Seaweed Extract",
    supplier: "Growganica",
    package: "8 oz",
    estimatedPrice: 24.99,
    url: "https://www.growganica.com/products/kelp-it-real-soluble-seaweed-extract",
    note: "Only for the 0.25% and 0.5% A/B paper modes.",
    defaultSelected: false,
  },
  {
    id: "biochar",
    category: "Paper additives",
    status: "Hold",
    name: "Wakefield Premium Biochar",
    supplier: "Wakefield BioChar",
    package: "2 qt trial size",
    estimatedPrice: null,
    url: "https://wakefieldbiochar.com/products/wakefield-biochar-premium-soil-conditioner/",
    note: "Held for a later adsorption test due to dust, residue, mold, and taste risk.",
    defaultSelected: false,
  },
  {
    id: "calcium-carbonate",
    category: "Paper additives",
    status: "Hold",
    name: "Calcium Carbonate Powder",
    supplier: "NOW Foods",
    package: "12 oz",
    estimatedPrice: 15.99,
    url: "https://www.nowfoods.com/products/supplements/calcium-carbonate-powder",
    note: "Use only if finished-paper leachate tests too acidic.",
    defaultSelected: false,
  },
  {
    id: "methocel",
    category: "Paper additives",
    status: "Hold",
    name: "Methocel A4C Food Grade",
    supplier: "Modernist Pantry",
    package: "50 g",
    estimatedPrice: 12.99,
    url: "https://modernistpantry.com/products/methocel-a4c-food-grade.html",
    note: "Use only if controlled sheets fail cracking or fold-strength gates.",
    defaultSelected: false,
  },
  {
    id: "ful-humix",
    category: "Paper additives",
    status: "Hold",
    name: "Ful-Humix",
    supplier: "BioAg",
    package: "Smallest available pack",
    estimatedPrice: null,
    url: "https://bioag.com/ful-humix",
    note: "Held due to discoloration, microbial, leachate, and taste risk.",
    defaultSelected: false,
  },
  {
    id: "pour-handmold",
    category: "Forming & grow-out",
    status: "Buy now",
    name: "Medium Pour Handmold",
    supplier: "Arnold Grummer",
    package: "1 forming kit",
    estimatedPrice: null,
    url: "https://arnoldgrummer.com/medium-pour-handmold.html",
    note: "Lab-scale sheet forming before a custom oval mold.",
    defaultSelected: true,
  },
  {
    id: "medium-screen",
    category: "Forming & grow-out",
    status: "Buy now",
    name: "Medium Papermaking Screen and Cover",
    supplier: "Arnold Grummer",
    package: "6.75 x 9.75 in set",
    estimatedPrice: 10.59,
    url: "https://arnoldgrummer.com/medium-papermaking-screen.html",
    note: "Extra forming and cover screen for continuous lab runs.",
    defaultSelected: true,
  },
  {
    id: "medium-couch-sheets",
    category: "Forming & grow-out",
    status: "Buy now",
    name: "Medium Couch Sheets",
    supplier: "Arnold Grummer",
    package: "20 pack, 6.5 x 9.5 in",
    estimatedPrice: 9.43,
    url: "https://arnoldgrummer.com/medium-couch-sheets-20-pack.html",
    note: "Reusable sheets for transferring, pressing, and drying wet paper.",
    defaultSelected: true,
  },
  {
    id: "trays",
    category: "Forming & grow-out",
    status: "Buy now",
    name: "Extra-Strength 1020 Trays",
    supplier: "Bootstrap Farmer",
    package: "No-hole and shallow trays",
    estimatedPrice: 25,
    url: "https://www.bootstrapfarmer.com/products/extra-strength-1020-tray",
    note: "Bottom watering, catchment, drying carry, and grow-out testing.",
    defaultSelected: true,
  },
  {
    id: "humidity-dome",
    category: "Forming & grow-out",
    status: "Buy now",
    name: "1020 Humidity Dome",
    supplier: "Bootstrap Farmer",
    package: "1 set",
    estimatedPrice: 20,
    url: "https://www.bootstrapfarmer.com/products/humidity-dome",
    note: "Controlled germination and vented humidity trials.",
    defaultSelected: true,
  },
  {
    id: "ph-meter",
    category: "QC & packaging",
    status: "Buy now",
    name: "PH20 pH Tester",
    supplier: "Apera Instruments",
    package: "1 kit",
    estimatedPrice: null,
    url: "https://aperainst.com/ph20-value-ph-meter-pocket-digital-tester-pen-kit-apera-instruments",
    note: "Finished-paper leachate QC.",
    defaultSelected: true,
  },
  {
    id: "ec-meter",
    category: "QC & packaging",
    status: "Buy now",
    name: "EC20 Conductivity Tester",
    supplier: "Apera Instruments",
    package: "1 meter",
    estimatedPrice: null,
    url: "https://aperainst.com/ec20-value-portable-pocket-conductivity-tester-meter-sensor",
    note: "Detect high-salt pulp, coco, or kelp batches.",
    defaultSelected: true,
  },
  {
    id: "scale",
    category: "QC & packaging",
    status: "Buy now",
    name: "Scout SPX222 0.01 g Scale",
    supplier: "OHAUS",
    package: "1 scale",
    estimatedPrice: null,
    url: "https://us.ohaus.com/en-us/products/balances-scales/portable-balances/scout-spx/spx222-am",
    note: "Seed and sub-0.1 g additive weighing.",
    defaultSelected: true,
  },
  {
    id: "desiccant",
    category: "QC & packaging",
    status: "Buy now",
    name: "1 g Food-Safe Silica Gel Packets",
    supplier: "Wisesorb",
    package: "Production pack",
    estimatedPrice: null,
    url: "https://wisesorbdesiccant.com/products/1g-food-grade-silica-gel-desiccant-packets",
    note: "One packet per fully dry refill pouch after shelf testing.",
    defaultSelected: true,
  },
  {
    id: "pouches",
    category: "QC & packaging",
    status: "Buy now",
    name: "4 oz Compostable Kraft Pouches",
    supplier: "Green Paper Products",
    package: "Case or sample pack",
    estimatedPrice: 24,
    url: "https://greenpaperproducts.com/products/4-oz-kraft-stand-up-pouches-compostable",
    note: "Dry refill packaging; verify folded-sheet fit and seal.",
    defaultSelected: true,
  },
];

export const orderCategories = ["Seeds", "Pulp & fiber", "Paper additives", "Forming & grow-out", "QC & packaging"];
